export const isAddonRequired = (addons) => {
    for (let i = 0; i < addons?.length; i++) {
        if (addons[i].required){
            return true
        }else{
            for (let j = 0; j < addons[i].modifiers.length; j++) {
                for (let indexOfTags = 0; indexOfTags < addons[i].modifiers[j].modifierTags.length; indexOfTags++) {
                    if (addons[i].modifiers[j].modifierTags[indexOfTags].required){
                        return true
                    }
                }                
            }
        }        
    }
    return false;
}

